import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import { SubscriptionPlanModuleId, UserRole } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const CustomersPage = lazy(() => import("./CustomersPage"));
const TasksPage = lazy(() => import("@web-src/pages/Tasks"));
const TaskDetails = lazy(() => import("@web-src/pages/TaskDetails"));

export type CustomersPagesNavigationParams = {
  customersCustomers: PageNavParams;
  customersTasks: PageNavParams<{ customerId: string }>;
  customersTaskDetails: PageNavParams<{ customerId: string; taskId: string }>;
};

export const customersPagesNavigationConfig: ModulePagesConfig<CustomersPagesNavigationParams> =
  {
    customersCustomers: {
      element: <CustomersPage />,
      path: "customers",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clients,
      requiredModules: [SubscriptionPlanModuleId.clients],
    },
    customersTasks: {
      element: <TasksPage />,
      path: "/customers/:customerId/tasks",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clients,
      requiredModules: [SubscriptionPlanModuleId.clients],
    },
    customersTaskDetails: {
      element: <TaskDetails />,
      path: "/customers/:customerId/tasks/details/:taskId",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clients,
      requiredModules: [SubscriptionPlanModuleId.clients],
    },
  };
